import * as Sentry from '@sentry/vue'

export const useError = () => {
    const logError = ({ reason, data, level = 'error' }: { reason: string; data?: any; level?: 'error' | 'warning' | 'info' | 'debug' | 'fatal' }) => {
        if (import.meta.env.DEV) return console.warn('Sentry logging is disabled in development mode', { reason, data })

        if (level === 'error' || level === 'fatal') {
            const error = new Error(reason)

            console.error({ reason, data })
            Sentry.captureException(error, {
                extra: {
                    customData: JSON.stringify(data)
                },
                level
            })
        } else if (level === 'warning' || level === 'info' || level === 'debug') {
            console.warn({ reason, data })
            Sentry.captureMessage(reason, {
                extra: {
                    customData: JSON.stringify(data)
                },
                level
            })
        }
    }

    return {
        logError
    }
}
